import React from 'react';
// import { Markup } from 'interweave';
import { isMobileOnly } from "react-device-detect";
import moment from 'moment';
import ActiveUser from '../settings/ActiveUser';
import Config from '../../src/Config'
import { useNavigate } from 'react-router-dom';
import { get_order_oliverpos_product_discount_amount_meta_data } from './CommonWork';


/**
    * Created By :Shakuntala Jatav
    * @param {*} Obj 
    * @param {*} productlist 
    * Description : Filter title name from product list array and call if productRetrunDiv else return blank array
    */
export const productxRender = (Obj, productlist, setPayment) => {
    var customProductxField = new Array();
    var findProductValue = [];
    var displayname = ''
    var displayVal = ''
    if (Obj.variation_id !== null && Obj.variation_id !== undefined && Obj.variation_id !== 0) {
        findProductValue = productlist && productlist.filter(_item => (_item.WPID == Obj.variation_id));
        if (findProductValue && findProductValue.length > 0) {
            customProductxField = getAddonsField(Obj);
            if (Obj.booking && Obj.booking.length>0) {
                customProductxField = getBookingField(Obj);
            }
            customProductxField.push(findProductValue[0].Title);

        }
    }
    else {
        Object.keys(Obj).map(i => {
            findProductValue = productlist && productlist.filter(_item => (((_item.WPID == Obj[i]))));
            if (findProductValue && findProductValue.length > 0) {
                // customProductxField.push(findProductValue[0].Title); // no need to display title in case of simple
                customProductxField = getAddonsField(Obj);
                if (Obj.booking && Obj.booking.length>0) {
                    customProductxField = getBookingField(Obj);
                }

            }
        })
    }
    if (customProductxField && customProductxField.length > 0 && setPayment !== "setPayment") {
        customProductxField = productRetrunDiv(customProductxField)
    }
    return customProductxField;
}

export const getAddonsField = (Obj) => {
    var displayname = [];
    Obj.addons && Obj.addons.map((ad) => {
        var urlData = "";
        if (new RegExp("([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?").test(ad.value)) {
            urlData = (ad.value.substring(ad.value.lastIndexOf('/') + 1))// extract last index of url
        }

        // ***   check for booking data start and end date for activity print receipt   *** //
        if (ad.key == '_booking_start' || ad.key == '_booking_end') {
            var dateVal = parseFloat(ad.value)
            var bookingDate = new Date((dateVal))
            urlData = moment.unix(dateVal).format(`${ActiveUser.key.orderRecieptDateFormate}, ${ActiveUser.key.orderRecieptTimeFormate}`);
        }
        // ***  end booking *** //

        var displayVal = ad.display ? ad.display : urlData != '' ? urlData : ad.value;

        var _price = (ad.field_type && ad.field_type != "custom_price") && ad.price ?
            ad.price_type && ad.price_type == 'percentage_based' ? "(" + ad.price + "%)" : "($" + ad.price + ")"
            : "";
        var _displayname = (ad.name ? ad.name : ad.label ? ad.label : ad.key ? ad.key : '') + _price + ' - ' + displayVal
        displayname.push(_displayname);
    })
    if ((!Obj.addons || Obj.addons.length == 0) && Obj.pricing_item_meta_data && Obj.pricing_item_meta_data != "") {

        displayname.push({ "key": "required", "value": Obj.pricing_item_meta_data._measurement_needed + ' ' + Obj.pricing_item_meta_data._measurement_needed_unit });
        displayname.push({ "key": "price", "value": Obj.pricing_item_meta_data._price });
        displayname.push({ "key": "quantity", "value": Obj.pricing_item_meta_data._quantity });
    }
    return displayname;
}
export const getBookingField = (Obj) => {
    var displayname = [];
    var bookingData = Obj && Obj.booking ? Obj.booking : null
    if (bookingData && bookingData._start_date && bookingData._end_date && bookingData._booking_id) {
        // var startDate = new Date((bookingData._start_date)*1000)
        // var endDate = new Date((bookingData._end_date)*1000)
        var startDate = moment.unix(bookingData._start_date).format(`${ActiveUser.key.orderRecieptDateFormate}, ${ActiveUser.key.orderRecieptTimeFormate}`);
        var endDate = moment.unix(bookingData._end_date).format(`${ActiveUser.key.orderRecieptDateFormate}, ${ActiveUser.key.orderRecieptTimeFormate}`);
        //var _displayname = `booking id:${bookingData._booking_id};start date : ${startDate};<br/> end date : ${endDate}`
        //displayname.push(_displayname);s
        displayname.push({ "key": "booking id", "value": bookingData._booking_id })
        displayname.push({ "key": "start date", "value": startDate });
        displayname.push({ "key": "end date", "value": endDate });

    }
    return displayname;
}
/**
    * Created By :Shakuntala Jatav
    * @param {*} subproductlist 
    * Description : return div component for mobile view and web view 
    */

export const productRetrunDiv = (subproductlist, isPrintReceipt = false) => {
    var sub_title = '';
    //var sub_title =subproductlist.join(";<br/>")
    subproductlist.map((item, index) => {
        sub_title = sub_title + (index !== 0 ? ";<br/>" : "") + (item.key ? item.key + ":" + item.value : item.toString());
    })

    return (
        (isMobileOnly == true) ?
            <div className="font-italic">{sub_title}</div>
            : isPrintReceipt == true ?
                sub_title.toString()
                :
                <span className="comman_subtitle">{sub_title}</span>
    )

}

/**
     * Created By :Shakuntala Jatav
     * @param {*} product_id 
     * @param {*} productlist 
     * Description : Get product id for match and call productxRender function   
     */

export const productxArray = (product_id, productlist, setPayment, productXjson = "") => {
    var productxTagsField = localStorage.getItem('PRODUCTX_DATA') && JSON.parse(localStorage.getItem('PRODUCTX_DATA'));
    var obj = "";
    productxTagsField.map(prdx => {
        if (productlist !== null) {
            var _prodXJson = prdx;

            if (prdx.product_id == product_id && _prodXJson.strProductX == productXjson) {
                // *** check for productx addons, booking and measuremnt tye product *** //
                if ((prdx.variation && (prdx.Type == "variable" || prdx.Type == "simple" || prdx.variation_id !== 0) || ((prdx.addons && prdx.addons.length) || prdx.booking || prdx.pricing_item_meta_data))) {
                    obj = productxRender(prdx, productlist, setPayment);
                }
                else if (prdx.composite_data) {
                    obj = productxRender(prdx.composite_data, productlist, setPayment);
                }
                else if (prdx.stamp) {
                    obj = productxRender(prdx.stamp, productlist, setPayment);
                }
            }
        }
    })
    return obj;
}

/**
     * Created By :Shakuntala Jatav
     * @param {*} item 
     * Description : Retuen Tilte on print page if product is composite or not  
     */
export const showTitle = (item) => {
    var title = "";
    if (item.composite_product_key !== "" && item.composite_parent_key == "" && item.bundle_product_key == "" && item.bundled_parent_key == "") {
        title = item.name;
    } else if (item.composite_product_key == "" && item.composite_parent_key == "" && item.bundle_product_key == "" && item.bundled_parent_key == "") {
        title = item.name;
    } else if (item.composite_product_key == "" && item.composite_parent_key == "" && item.bundle_product_key !== "" && item.bundled_parent_key == "") {
        title = item.name;
    } else if ((typeof item.composite_product_key == 'object') && (typeof item.composite_parent_key == 'object') && (typeof item.bundle_product_key == 'object') && (typeof item.bundled_parent_key == 'object')) {
        title = item.name;
    } else {
        title = "";
    }
    return title;
}

/**
     * Created By :Shakuntala Jatav
     * @param {*} item 
     * Description : Retuen sub-tilte on print page if product is composite child or not  
     */
export const showSubTitle = (item) => {
    var subTitle = "";
    if (item.composite_product_key !== "" && item.composite_parent_key !== "" && item.bundle_product_key == "" && item.bundled_parent_key == "") {
        subTitle = item.name;
    } else if (item.composite_product_key == "" && item.composite_parent_key == "" && item.bundle_product_key !== "" && item.bundled_parent_key !== "") {
        subTitle = item.name;
    }
    // else if (item && item.meta && item.meta !== "[]") {
    //     var prodXMeta = item.meta && item.meta !== '[]' && item.meta !== [] ? JSON.parse(item.meta) : ''
    //     var addonsMeta = ''
    //     // get meta values from meta field for addons and measurment types
    //     var metaValues = prodXMeta && prodXMeta !== '' ? prodXMeta.map(function (el) {
    //         // check if value contains url and get last index of url
    //         if (new RegExp("([a-zA-Z0-9]+://)?([a-zA-Z0-9_]+:[a-zA-Z0-9_]+@)?([a-zA-Z0-9.-]+\\.[A-Za-z]{2,4})(:[0-9]+)?(/.*)?").test(el.value)) {
    //             var urlData = (el.value.substring(el.value.lastIndexOf('/') + 1))// extract last index of url
    //             return ` ${el.key} - ${urlData} `
    //         }
    //         return ` ${el.key} - ${el.value} ` // return key and value of meta data

    //     }) : '';

    //     addonsMeta = metaValues !== '' ? metaValues.toString() : addonsMeta

    // }
    else {
        subTitle = "";
    }
    return subTitle;
}

/**
 * Created By :Shakuntala Jatav
 * Created Date: 26-feb-2020
 * Description: Return boolen for allow permission for discount is or not!
 */
export const permissionsForDiscount = () => {
    var allowDiscount = false;
    var userLocal = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : '';
    var userData = userLocal && userLocal.permissions;
    var _allowDiscount = userData && userData.filter(perm => (perm.PermissionKey && perm.PermissionKey == 'GiveDiscount' && perm.IsAllow));
    if (_allowDiscount && _allowDiscount.length > 0) {
        return allowDiscount = (_allowDiscount[0].PermissionKey == 'GiveDiscount' && _allowDiscount[0].IsAllow == true) ? true : false;
    }
    return allowDiscount;
}

/**
 * Created By :Shakuntala Jatav
 * Created Date: 26-feb-2020
 * Description: Return boolen for allow permission for refund is or not!
 */
export const permissionsForRefund = () => {
    var allowRefund = false;
    var userLocal = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : '';
    var userData = userLocal && userLocal.permissions;
    var _allowRefund = userData && userData.filter(perm => (perm.PermissionKey && perm.PermissionKey == 'IssueRefund' && perm.IsAllow));
    if (_allowRefund && _allowRefund.length > 0) {
        return allowRefund = (_allowRefund[0].PermissionKey == 'IssueRefund' && _allowRefund[0].IsAllow == true) ? true : false;
    }
    return allowRefund;
}
export const permissionsForDeleteNotes = () => {
    var allowDeleteNotes = false;
    var userLocal = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : '';
    var userData = userLocal && userLocal.permissions;
    var allowDeleteNotes = userData && userData.filter(perm => (perm.PermissionKey && perm.PermissionKey == 'DeleteCustomerNotes' && perm.IsAllow));
    if (allowDeleteNotes && allowDeleteNotes.length > 0) {
        return allowDeleteNotes = (allowDeleteNotes[0].PermissionKey == 'DeleteCustomerNotes' && allowDeleteNotes[0].IsAllow == true) ? true : false;
    }
    return allowDeleteNotes;
}

export const permissionsForPrintEOD = () => {
    var alloPrintEOD = false;
    var userLocal = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : '';
    var userData = userLocal && userLocal.permissions;
    var alloPrintEOD = userData && userData.filter(perm => (perm.PermissionKey && perm.PermissionKey == 'PrintEOD' && perm.IsAllow));
    if (alloPrintEOD && alloPrintEOD.length > 0) {
        return alloPrintEOD = (alloPrintEOD[0].PermissionKey == 'PrintEOD' && alloPrintEOD[0].IsAllow == true) ? true : false;
    }
    return alloPrintEOD;
}

export const permissionsForDeleteCustomer = () => {
    var allowDeleteCustomer = false;
    var userLocal = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")) : '';
    var userData = userLocal && userLocal.permissions;
    var allowDeleteCustomer = userData && userData.filter(perm => (perm.PermissionKey && perm.PermissionKey == 'DeleteCustomer' && perm.IsAllow));
    if (allowDeleteCustomer && allowDeleteCustomer.length > 0) {
        return allowDeleteCustomer = (allowDeleteCustomer[0].PermissionKey == 'DeleteCustomer' && allowDeleteCustomer[0].IsAllow == true) ? true : false;
    }
    return allowDeleteCustomer;
}







export const showProductxModal = () => {
    var productxPermission = localStorage.getItem('clientDetail') ? JSON.parse(localStorage.getItem('clientDetail')).subscription_permission.product_x : false;
    return productxPermission;
}
export const getInclusiveTaxType = (meta_datas) => {
    var taxInclusiveName = "";
   var _metaData= get_order_oliverpos_product_discount_amount_meta_data(meta_datas,true);
    // meta_datas && meta_datas.map((meta) => {

        // var _metaData;
        // if (meta._order_oliverpos_product_discount_amount) {
        //     _metaData = meta._order_oliverpos_product_discount_amount
        // }
        // if (meta.ItemName === '_order_oliverpos_product_discount_amount') {
        //     _metaData = meta.ItemValue && meta.ItemValue !== "" && JSON.parse(meta.ItemValue);
        // }
        _metaData && _metaData.map((item, index) => {
            if (item.taxType && item.taxType !== null) {
                taxInclusiveName = item.taxType.toLowerCase() === 'incl' ? "(Incl)" : "";
            }
        });

    // })
    return taxInclusiveName;
}

export const RememberData = (val) => {
    var data = {};
    if (val == "set") {
        data["LANG"] = localStorage.getItem("LANG") ? localStorage.getItem("LANG") : null;
        data["sitelist"] = localStorage.getItem("sitelist") ? localStorage.getItem("sitelist") : null;
        data["userId"] = localStorage.getItem("userId") ? localStorage.getItem("userId") : null;
        data["clientDetail"] = localStorage.getItem("clientDetail") ? localStorage.getItem("clientDetail") : null;
        data["hasPin"] = localStorage.getItem("hasPin") ? localStorage.getItem("hasPin") : null;
        data["IsCashDrawerOpen"] = localStorage.getItem("IsCashDrawerOpen") ? localStorage.getItem("IsCashDrawerOpen") : null;
        data["user_full_name"] = localStorage.getItem("user_full_name") ? localStorage.getItem("user_full_name") : null;
        data["UDID"] = localStorage.getItem("UDID") ? localStorage.getItem("UDID") : null;
        data["UserLocations"] = localStorage.getItem("UserLocations") ? localStorage.getItem("UserLocations") : null;
        data["Location"] = localStorage.getItem("Location") ? localStorage.getItem("Location") : null;
        data["LocationName"] = localStorage.getItem("LocationName") ? localStorage.getItem("LocationName") : null;
        data["WarehouseId"] = localStorage.getItem("WarehouseId") ? localStorage.getItem("WarehouseId") : null;
        data["pdf_format"] = localStorage.getItem("pdf_format") ? localStorage.getItem("pdf_format") : null;
        data["register"] = localStorage.getItem("register") ? localStorage.getItem("register") : null;
        data["registerName"] = localStorage.getItem("registerName") ? localStorage.getItem("registerName") : null;
        data["selectedRegister"] = localStorage.getItem("selectedRegister") ? localStorage.getItem("selectedRegister") : null;
        data["Cash_Management_ID"] = localStorage.getItem("Cash_Management_ID") ? localStorage.getItem("Cash_Management_ID") : null;
        data["AUTH_KEY"] = localStorage.getItem("AUTH_KEY") ? localStorage.getItem("AUTH_KEY") : null;
        data["Cash_Management_ID"] = localStorage.getItem("Cash_Management_ID") ? localStorage.getItem("Cash_Management_ID") : null;
        //data["user"] = localStorage.getItem("user") ? localStorage.getItem("user") : null;
        localStorage.setItem("remember_data", JSON.stringify(data));
    }
    else if (val == "get") {
        if (localStorage.getItem("remember_data")) {
            data = JSON.parse(localStorage.getItem("remember_data"))
            localStorage.setItem("LANG", data["LANG"]);
            localStorage.setItem("sitelist", data["sitelist"]);
            localStorage.setItem("userId", data["userId"]);
            localStorage.setItem("clientDetail", data["clientDetail"]);
            localStorage.setItem("hasPin", data["hasPin"]);
            localStorage.setItem("IsCashDrawerOpen", data["IsCashDrawerOpen"]);
            localStorage.setItem("user_full_name", data["user_full_name"]);
            localStorage.setItem("UDID", data["UDID"]);
            localStorage.setItem("UserLocations", data["UserLocations"]);
            localStorage.setItem("Location", data["Location"]);
            localStorage.setItem("LocationName", data["LocationName"]);
            localStorage.setItem("WarehouseId", data["WarehouseId"]);
            localStorage.setItem("pdf_format", data["pdf_format"]);
            localStorage.setItem("register", data["register"])
            localStorage.setItem("registerName", data["registerName"]);
            localStorage.setItem("selectedRegister", data["selectedRegister"]);
            localStorage.setItem("Cash_Management_ID", data["Cash_Management_ID"]);
            // sessionStorage.setItem("AUTH_KEY", data["AUTH_KEY"]);
            localStorage.setItem("AUTH_KEY", data["AUTH_KEY"]);
            //localStorage.setItem("user", data["user"]);
        }
    }
}
export const checkRelogin = () => {
    // if (!sessionStorage.getItem("AUTH_KEY")) {
    //     if (localStorage.getItem("remember_data")) {
    //         RememberData("get")
    //         return;
    //     }
    // }
    if (!localStorage.getItem("AUTH_KEY")) {
        if (localStorage.getItem("remember_data")) {
            RememberData("get")
            return;
        }
    }
}
export const NavigateComponent = (navigate,componentName) => {
    //const navigate=useNavigate();
    if (componentName){
        if(window.location.hostname == Config.key.DEMO_USER_URL){ 
                if (componentName.toLowerCase()=="pin") {       
                        //navigate('/pin?product_tour_id=439368')
                        window.location.href ='/pin?product_tour_id='+Config.key.TOUR_PIN_KEY;
                    }
                    else  if (componentName.toLowerCase()=="home") { 
                        // navigate('/home?product_tour_id=437713')
                    window.location.href = '/home?product_tour_id='+Config.key.TOUR_HOME_KEY;
                    }
                //     else  if (componentName.toLowerCase()=="salecomplete") { 
                //        // navigate('/salecomplete?product_tour_id=439689')
                //         window.location.href ='/salecomplete?product_tour_id=439689'
                 //   }
                    else{
                        navigate("/"+componentName);
                    }
                
            }else{
                navigate("/"+componentName);
            }
}
}


 // if
	// "StockStatus": "instock",
    // "BackOrdered": "no",  nothing will do work as we doing
	
    // if  "StockStatus": "instock",
    //     "BackOrdered": "yes", only allow backorder
        
    // if  "StockStatus": "instock",
    //     "BackOrdered": "notify",  then allow backorder and show in frontend and sent backorder and quantity in order details
        
    // if  "StockStatus": "outofstock",
    //     "BackOrdered": "no",  then product is outof stock

     // if  "StockStatus": "outofstock",
    //     "BackOrdered": "yes",  only allow backorder

    // if "StockStatus": "onbackorder",
    //     "BackOrdered": "no",  only allow backorder
    
export const CheckProductBackordered=(product)=>{
     var isBackOrdereTemp=false;
     if(product){
        const { StockStatus, BackOrderd } = product;   
        if (StockStatus === 'instock' && BackOrderd === 'no' ) {
            isBackOrdereTemp = false
        } else if ((StockStatus === 'instock' || StockStatus ==='onbackorder') && BackOrderd === 'yes') {
            isBackOrdereTemp = true    
        } else if ((StockStatus === 'instock' || StockStatus ==='onbackorder') && BackOrderd === 'notify') {
            isBackOrdereTemp = true  
        } else if (StockStatus === 'outofstock' && (BackOrderd === 'yes' || BackOrderd === 'notify')) {
            isBackOrdereTemp = true
        } else if (StockStatus === 'outofstock' && BackOrderd === 'no') {
            isBackOrdereTemp = false
        } else if (StockStatus === 'onbackorder' && BackOrderd === 'no') {
            isBackOrdereTemp = false
        }
    }
    return isBackOrdereTemp;
}
export const getNewReceiptId=()=>{
    const register_Id = localStorage.getItem('register');
    var location_id = localStorage.getItem('Location');
    const TwoDigitRId = register_Id.toString().padStart(2, '0');
    const TwoDigitLId = location_id.toString().padStart(2, '0');
    const TwelveDigitDateUtc = Math.floor(Date.now() / 1000).toString();
    const ReciptId = `${TwoDigitLId}${TwoDigitRId}${TwelveDigitDateUtc}`;
    return ReciptId;
}
export const CommonModuleJS = {
    productxArray, productxRender, permissionsForDeleteNotes, showTitle, showSubTitle, permissionsForDiscount, permissionsForRefund, showProductxModal,
    getInclusiveTaxType, RememberData, permissionsForPrintEOD, permissionsForDeleteCustomer, checkRelogin,NavigateComponent,CheckProductBackordered,
    getNewReceiptId
}

export default CommonModuleJS;